export default __webpack_public_path__ + "static/media/silver-tag.c51c096b.png";